import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { FormProvider } from '@xmanscript/useform';
import { Auth0Provider } from '@auth0/auth0-react';
import App from './App';
import './assets/css/index.css';
import registerSW from './pwa/registerSW';
import { UserProvider } from './contexts/UserContext/UserContext';
import { manualLogout, clearAuthData } from './utils/manualLogout';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
      // retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    },
  },
});

// Register service worker for PWA
if (import.meta.env.PROD) {
  registerSW();
}

// Expose manual logout functions globally for easy access
window.manualLogout = manualLogout;
window.clearAuthData = clearAuthData;

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <QueryClientProvider client={queryClient}>
    <Auth0Provider
      domain={import.meta.env.VITE_AUTH0_DOMAIN}
      clientId={import.meta.env.VITE_AUTH0_CLIENT_ID}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: import.meta.env.VITE_AUTH0_AUDIENCE,
        scope: 'openid profile email',
      }}
      cacheLocation="localstorage"
      useRefreshTokens={true}
    >
      <GoogleOAuthProvider clientId={import.meta.env.VITE_GOOGLE_CLIENT_ID || ''}>
        <UserProvider>
          <BrowserRouter>
            <FormProvider>
              <App />
            </FormProvider>
          </BrowserRouter>
        </UserProvider>
      </GoogleOAuthProvider>
    </Auth0Provider>
  </QueryClientProvider>,
);